import { api } from '../utils/axios';


export const getBanners = () => async (dispatch) => {
  
  let data = {};
  dispatch({
    type: "BANNERS_REQUESTED"
  })

  try {
    const response = await api.post('admin/get_banners', data);
    dispatch({
      type: "BANNERS_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "BANNERS_FAILED",
      error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    })
    const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);
  
    
  }
}


export const saveBanner = (data) => async (dispatch) => {
  
  dispatch({
    type: "SAVE_BANNERS_REQUESTED"
  })

  try {
    const response = await api.post('admin/save_banner', { target_banner: data });
    dispatch({
      type: "SAVE_BANNERS_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

  }
}


export const deleteBanner = (data) => async (dispatch) => {
  
  dispatch({
    type: "DELETE_BANNERS_REQUESTED"
  })

  try {
    const response = await api.post('admin/delete_banner', { target_banner: data });
    dispatch({
      type: "DELETE_BANNERS_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

  }
}


